export const normalizeBoundary = (boundary) => {
  if (!boundary) {
    return null;
  }

  if (typeof boundary === "string") {
    try {
      return JSON.parse(boundary);
    } catch (error) {
      return null;
    }
  }

  return Array.isArray(boundary) ? boundary : null;
};

export const prepareBoundaryForSave = (boundary) => {
  const points = normalizeBoundary(boundary);
  if (!points || points.length < 3) {
    return null;
  }

  const cleaned = points.map((point) => [
    Number(Number(point[0]).toFixed(6)),
    Number(Number(point[1]).toFixed(6)),
  ]);

  const first = cleaned[0];
  const last = cleaned[cleaned.length - 1];
  if (first[0] === last[0] && first[1] === last[1]) {
    cleaned.pop();
  }

  return cleaned.length >= 3 ? cleaned : null;
};

export const getBoundaryCenter = (boundary, fallback) => {
  const points = normalizeBoundary(boundary);
  if (!points?.length) {
    return (
      fallback || {
        longitude: 87.68,
        latitude: 43.77,
      }
    );
  }

  const totals = points.reduce(
    (acc, point) => ({
      lng: acc.lng + Number(point[0]),
      lat: acc.lat + Number(point[1]),
    }),
    { lng: 0, lat: 0 }
  );

  return {
    longitude: totals.lng / points.length,
    latitude: totals.lat / points.length,
  };
};
